import styled from "styled-components";

export const Section = styled.section`
  ${({ theme }) => theme['end-route']?.section}
`;